<template>
  <div class="about-us">
    <div class="about-us__container">
      <div class="about-us__background">
        <img class="about-us__bg-image" src="@/assets/about-bg.png" alt="" />
        <div class="about-us__bg-overlay"></div>
      </div>
      <div class="about-us__content">
        <div class="about-us__title-container">
          <div class="about-us__title">About {{domainConfig?.AboutTitle}}</div>
          <div class="about-us__title-underline"></div>
        </div>
        <div class="about-us__description" v-html="domainConfig?.AboutContent"></div>

        <a class="about-us__action" :href="downloadLink">
          <div class="about-us__action-text">Download Movies & TV shows</div>
          <img class="about-us__action-arrow" src="@/assets/icon/arrow_right_alt.svg" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AboutUs',
  computed: {
    ...mapGetters({
      domainConfig: 'domainConfig'
    }),
    downloadLink () {
      const channel = this.$route.params.channel ? `/${this.$route.params.channel}` : '';
      return `${channel}/movie-download/`;
    }
  },
  methods: {
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.about-us {
	padding: 0 rem(80);
	display: flex;
	flex-direction: column;
	gap: rem(10);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin-bottom: rem(88);

	&__container {
		width: 100%;
		height: rem(400);
		position: relative;
		border-radius: rem(16);
		overflow: hidden;
	}

	&__background {
		width: 100%;
		height: 100%;
		position: relative;
	}

	&__bg-image {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		object-fit: cover;
	}

	&__bg-overlay {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		background: rgba(13, 12, 15, 0.7);
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(32);
		align-items: center;
		justify-content: flex-start;
		width: rem(880);
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	&__title-container {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: center;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__title-underline {
		background: #fe324b;
		width: rem(32);
		height: rem(4);
		position: relative;
	}

	&__description {
		color: #ffffff;
		text-align: center;
		font-size: rem(14);
		line-height: rem(24);
		font-weight: 400;
		position: relative;
		align-self: stretch;
		strong {
			font-weight: 800;
		}
		a {
			color: #fe324b;
		}
	}

	&__action {
		background: #fe324b;
		border-radius: 100px;
		padding: rem(12) rem(24);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
	}

	&__action-text {
		color: #ffffff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		position: relative;
	}

	&__action-arrow {
		width: rem(16);
		height: rem(12);
		position: relative;
		filter: brightness(0) invert(1);
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.about-us {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.about-us {
		padding: 0 rem(16);

		&__content {
			width: calc(100% - rem(32));
			padding: 0 rem(16);
		}

		&__description {
			font-size: rem(12);
			line-height: rem(20);
		}
	}
}
</style> 